import axios from '../api/axios';

export async function assignLogoToUser(userId, logoId) {

  const response = await axios.patch(`/users/${userId}/logos/${logoId}`);

  return response.data;
}

export async function deleteLogoFromUser(userId, logoId) {
  const response = await axios.delete(`/users/${userId}/logos/${logoId}`);
  return response;
}